/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { getOptionLabelFromIndex } from '../../utils';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import { SafeHTML } from 'edrolo/domains/app';
import styles from './styles.scss';

export const SingleSelector = ({
  answers,
  correctAnswers,
  selectedAnswerId,
  onChange,
  disabled,
}) => {
  const isCorrectAnswer = (answerId) => {
    return correctAnswers && correctAnswers.indexOf(answerId) > -1;
  };

  const isIncorrectAnswer = (answerId) => {
    return correctAnswers && correctAnswers.indexOf(answerId) === -1;
  };

  const renderAnswers = () => {
    return answers.map((answer, index) => {
      const answerId = answer.get('id');
      const selected = answerId === +selectedAnswerId;
      const correct = isCorrectAnswer(answerId);
      const incorrect = isIncorrectAnswer(answerId);

      // Questions with more than 26 options will not show labels
      const optionLabel = getOptionLabelFromIndex(index);

      return (
        <li
          key={answerId}
          className={cx({
            [styles.selectedAnswer]: selected,
            [styles.answer]: !selected,
            [styles.disabledAnswer]: disabled,
          })}
          onClick={() => !disabled && onChange(answerId)}
          data-test="multi-choice-answer"
        >
          <span className={styles.optionLabel}>{optionLabel}</span>
          {correct && selected && (
            <span
              className={styles.correctSelection}
              data-test="multi-choice-answer-correct"
            />
          )}
          {incorrect && selected && (
            <span
              className={styles.incorrectSelection}
              data-test="multi-choice-answer-incorrect"
            />
          )}
          <div
            className={correct ? styles.correctAnswerHtml : styles.answerHtml}
          >
            <SafeHTML>{answer.get('text')}</SafeHTML>
          </div>
        </li>
      );
    });
  };

  return (
    <ul
      className={styles.answers}
      data-test={`${disabled ? 'answer' : 'question'}-${
        EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE
      }`}
    >
      {renderAnswers()}
    </ul>
  );
};
